import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { PaymentsBasePage } from '@payments/payments-shared/payments-base/payments-base.page';
import { PaymentsService } from '@payments/services/payments.service';
import { FormControl } from '@angular/forms';
import { AchFormStoreService } from '@usf/ngrx-payment';
import { Observable, Subject, filter, takeUntil } from 'rxjs';
import { AchFormState } from '@usf/ngrx-payment/lib/models/state/ach-form.state';
import { ModalController } from '@ionic/angular';
import { LoadingSpinnerComponent } from '@shared/components/popovers/loading-spinner/loading-spinner.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ach-form-retrieval',
  templateUrl: './ach-form-retrieval.page.html',
  styleUrls: ['./ach-form-retrieval.page.scss'],
})
export class AchFormRetrievalPage
  extends PaymentsBasePage
  implements OnDestroy
{
  auditIdControl = new FormControl('');
  private destroy$ = new Subject<void>();
  isAR$ = this.paymentsService.isUSFoodsAR();
  achAuditID: string;

  constructor(
    readonly platformService: PlatformService,
    public router: Router,
    readonly route: ActivatedRoute,
    readonly paymentsService: PaymentsService,
    private modalController: ModalController,
    private translateService: TranslateService,
    readonly panAppState: PanAppState,
    private achFormStoreService: AchFormStoreService,
  ) {
    super(router, route, paymentsService);
  }
  // ag-todo: use browser page title enum
  ionViewWillEnter(): void {
    super.ionViewWillEnter();
    this.panAppState.setPageTitle('Autopay Setup Form Retrieval | US Foods');
  }

  async getGeneratedACHFormID(auditId: string): Promise<void> {
    if (!auditId?.trim()) {
      return;
    }
    // AG-TODO: Implement form retrieval logic
    const loadingSpinnerModal = await this.loadingModal(
      'i18n.payments.achFormRetrieval.loadingAuditID',
    );

    this.achFormStoreService.getGeneratedACHForm(auditId);

    (this.achFormStoreService.getAchFormState$() as Observable<AchFormState>)
      .pipe(filter(achState => !achState.loading))
      .subscribe(state => {
        // ag-todo: implement these handler laters state.error and state.warning later
        loadingSpinnerModal?.dismiss();
        this.showAchAuditID(state.achAuditID);
      });
  }

  async showAchAuditID(achAuditID: string) {
    this.achAuditID = achAuditID;
  }

  async loadingModal(
    loadingMessage = 'i18n.payments.reviewAndSubmit.saving',
  ): Promise<HTMLIonModalElement> {
    const loadingSpinnerModal = await this.modalController.create({
      component: LoadingSpinnerComponent,
      backdropDismiss: false,
      cssClass: 'modal-loading-spinner',
      componentProps: {
        loadingSpinnerModalMessage:
          this.translateService.instant(loadingMessage),
      },
    });

    await loadingSpinnerModal?.present();

    return loadingSpinnerModal;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
